import 'ol/ol.css';
import olms from 'ol-mapbox-style';

olms('map', 'data/wms.json');
